import { IconButton } from "@fluentui/react";
import { Close } from "@mui/icons-material";
import { Box, Drawer, Typography } from "@mui/material";
import React, { ReactNode, useState } from "react";

interface IKeyDriveDrawerButton {
    text: string;
    icon: React.ReactNode;
    onClick: () => void;
}

interface IKeyDriveDrawer {
    children: ReactNode;
    iconTitle?: React.ReactNode;
    title?: string;
    subTitle?: string;
    isOpen: boolean;
    onClose?: () => void;
}

export const KeyDriveDrawer: React.FC<IKeyDriveDrawer> = ({
    iconTitle,
    title,
    subTitle,
    isOpen,
    onClose,
    children
}) => {

    const handleClose = () => {
        if (onClose) onClose();
    };
    return (
        <Drawer anchor={"right"} open={isOpen} onClose={() => handleClose()}>
            <Box sx={{ width: "500px", padding: "20px" }}>
                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                        {iconTitle}
                        <Typography sx={{ font: "normal normal bold 20px/30px Segoe UI;" }}>{title}</Typography>
                    </Box>
                    { onClose != null &&
                    <IconButton onClick={() => handleClose()}>
                        <Close  sx={{color: "#000000"}}/>
                    </IconButton>
                    }
                </Box>
                <Box>
                    <Typography sx={{ font: "normal normal normal 14px/21px Segoe UI", letterSpacing: 0, opacity: "1" }}>
                        {subTitle}
                    </Typography>
                </Box>
                {children}
            </Box>

        </Drawer>
    )
}